// extracted by mini-css-extract-plugin
export default {"modal":"modal__IIl6C","modal__content":"modal__content__fROEM"};